  <template>

  <div class="dashboard">
    <row v-if="!$root.isCustomer">
      <div class="col-lg-3 col-xs-6">
        <va-small-box v-if="$root.isAdmin"
                      color="aqua"
                      icon="ion-bag"
                      :title="$root.dashData.TotalDealers?$root.dashData.TotalDealers:0"
                      description="Dealers"
                      @more-click="$root.goto('Dealers')"
                      moreText="More info">
        </va-small-box>
        <va-small-box v-else-if="$root.isDealer || $root.isDealerAssistance"
                      color="aqua"
                      icon="ion-bag"
                      :title="$root.dashData.TotalCustomers?$root.dashData.TotalCustomers:0"
                      description="Customers"
                      @more-click="$root.goto('Customers')"
                      moreText="More info">
        </va-small-box>
      </div>
      <div class="col-lg-3 col-xs-6">
        <va-small-box color="green"
                      icon="ion-stats-bars"
                      :title="$root.dashData.TotalSites?$root.dashData.TotalSites:0"
                      description="Sites"
                      @more-click="$root.goto('Sites')"
                      moreText="More info">
        </va-small-box>
      </div>
      <div class="col-lg-3 col-xs-6">
        <va-small-box color="yellow"
                      icon="ion-printer"
                      :title="$root.dashData.TotalPrinters?$root.dashData.TotalPrinters:0"
                      description="Printers"
                      @more-click="$root.goto('AllPrinters')"
                      moreText="More info">
        </va-small-box>
      </div>
      <div class="col-lg-3 col-xs-6">
        <va-small-box color="red"
                      icon="ion-person"
                      :title="$root.dashData.TotalUsers?$root.dashData.TotalUsers:0"
                      description="Users"
                      @more-click="$root.goto('Users')"
                      moreText="More info">
        </va-small-box>
      </div>
    </row>
    <row v-if="$root.isCustomer">
      <div class="col-lg-4 col-xs-6">
        <va-small-box color="aqua"
                      icon="ion-user"
                      title="Welcome"
                      :description="userFullName">
        </va-small-box>
      </div>
      <div class="col-lg-4 col-xs-6">
        <va-small-box color="green"
                      icon="ion-printer"
                      :title="$root.dashData.TotalPrinters?$root.dashData.TotalPrinters:0"
                      description="Printers"
                      @more-click="$root.goto('Printers')"
                      moreText="More info">
        </va-small-box>
      </div>
      <div class="col-lg-4 col-xs-6">
        <va-small-box color="yellow"
                      icon="ion-stats-bars"
                      :title="$root.dashData.TotalSites?$root.dashData.TotalSites:0"
                      description="Sites"
                      @more-click="$root.goto('Sites')"
                      moreText="More info">
        </va-small-box>
      </div>
    </row>
    <row>
      <div class="col-md-12">
        <div class="box">
          <div class="box-header with-border">
            <!--<h3 class="box-title">Monthly Counter Report</h3>-->
          </div>
          <!-- /.box-header -->
          <div class="box-body">
            <row>
              <!--<div class="col-md-6">
            <p class="text-center">
              <strong>Counters (Last 3 Months)</strong>
            </p>
            <div class="chart">
              <va-chart v-if="hasChartData" :chart-config='$root.dashData.barChartData'></va-chart>
            </div>
          </div>-->
              <div class="col-md-8">
                <p class="text-center">
                  <strong>Recent System Alerts</strong>
                </p>
                <div class="chart">
                  <VueTable ref="vueTableAlerts" :guid="guidAlerts" :isPaging="false" :info="infoIcons" :columns="alertsColumns" :rows="$root.dashData.recentAlerts" @rowClick="rowClick"></VueTable>
                </div>
              </div>
              <!-- /.col -->
              <div class="col-md-4">

                <p class="text-center">
                  <a href="#" @click="$root.goto('PrintersStatus')">
                    <strong style="color: #000;">Printers Status</strong>
                  </a>
                </p>
                <!-- /.progress-group -->
                <div class="progress-group" @click="$root.goto('PrintersOnline')">
                  <span class="progress-text">Online</span>
                  <span class="progress-number"><b>{{$root.dashData.PrintersStatus?$root.dashData.PrintersStatus.TotalOnline:0}}</b>/{{$root.dashData.TotalPrinters}}</span>
                  <div class="progress sm">
                    <div class="progress-bar progress-bar-green" :style="{ width: $root.dashData.PrintersStatusPercent.TotalOnline }"></div>
                  </div>
                </div>
                <!-- /.progress-group -->
                <div class="progress-group" @click="$root.goto('PrintersOffline')">
                  <span class="progress-text">Offline</span>
                  <span class="progress-number"><b>{{$root.dashData.PrintersStatus?$root.dashData.PrintersStatus.TotalOffline:0}}</b>/{{$root.dashData.TotalPrinters}}</span>
                  <div class="progress sm">
                    <div class="progress-bar progress-bar-red" :style="{ width: $root.dashData.PrintersStatusPercent.TotalOffline }"></div>
                  </div>
                </div>
                <div class="progress-group" @click="$root.goto('PrintersOutOfPaper')">
                  <span class="progress-text">Out of Paper</span>
                  <span class="progress-number"><b>{{$root.dashData.PrintersStatus?$root.dashData.PrintersStatus.TotalOutPaper:0}}</b>/{{$root.dashData.TotalPrinters}}</span>
                  <div class="progress sm">
                    <div class="progress-bar progress-bar-aqua" :style="{ width: $root.dashData.PrintersStatusPercent.TotalOutPaper }"></div>
                  </div>
                </div>
                <div class="progress-group" @click="$root.goto('PrintersLowToner')">
                  <span class="progress-text">Low Toner</span>
                  <span class="progress-number"><b>{{$root.dashData.PrintersStatus?$root.dashData.PrintersStatus.TotalOutToner:0}}</b>/{{$root.dashData.TotalPrinters}}</span>
                  <div class="progress sm">
                    <div class="progress-bar progress-bar-aqua" :style="{ width: $root.dashData.PrintersStatusPercent.TotalOutToner }"></div>
                  </div>
                </div>
                <!-- /.progress-group -->
                <div class="progress-group" @click="$root.goto('PrintersErrors')">
                  <span class="progress-text">Errors</span>
                  <span class="progress-number"><b>{{$root.dashData.PrintersStatus?$root.dashData.PrintersStatus.TotalError:0}}</b>/{{$root.dashData.TotalPrinters}}</span>
                  <div class="progress sm">
                    <div class="progress-bar progress-bar-yellow" :style="{ width: $root.dashData.PrintersStatusPercent.TotalError }"></div>
                  </div>
                </div>
                <!-- /.progress-group -->
                
               
               
              </div>
              <!-- /.col -->
            </row>
            <!-- /.row -->
          </div>
          <!-- ./box-body -->
          <div class="box-footer" v-show="showAccounting">
            <row>
              <div class="col-sm-3 col-xs-6">
                <div class="description-block border-right">
                  <span class="description-percentage text-green"><i class="fa fa-caret-up"></i> 17%</span>
                  <h5 class="description-header">$35,210.43</h5>
                  <span class="description-text">TOTAL REVENUE</span>
                </div>
                <!-- /.description-block -->
              </div>
              <!-- /.col -->
              <div class="col-sm-3 col-xs-6">
                <div class="description-block border-right">
                  <span class="description-percentage text-yellow"><i class="fa fa-caret-left"></i> 0%</span>
                  <h5 class="description-header">$10,390.90</h5>
                  <span class="description-text">TOTAL COST</span>
                </div>
                <!-- /.description-block -->
              </div>
              <!-- /.col -->
              <div class="col-sm-3 col-xs-6">
                <div class="description-block border-right">
                  <span class="description-percentage text-green"><i class="fa fa-caret-up"></i> 20%</span>
                  <h5 class="description-header">$24,813.53</h5>
                  <span class="description-text">TOTAL PROFIT</span>
                </div>
                <!-- /.description-block -->
              </div>
              <!-- /.col -->
              <div class="col-sm-3 col-xs-6">
                <div class="description-block">
                  <span class="description-percentage text-red"><i class="fa fa-caret-down"></i> 18%</span>
                  <h5 class="description-header">1200</h5>
                  <span class="description-text">GOAL COMPLETIONS</span>
                </div>
                <!-- /.description-block -->
              </div>
            </row>
            <!-- /.row -->
          </div>
          <!-- /.box-footer -->
        </div>
        <!-- /.box -->
      </div>
      <!-- /.col -->
      <DownloadInstaller></DownloadInstaller>
    </row>
    <loading :active.sync="$root.isLoading" :is-full-page="isFullpage"></loading>
    
  </div>
</template>
<script>
  import { db } from '../firebase'
  import { CalculateDashboard } from '../plugins/dashboard.js'
  import VueTable from '../components/Table/DataTable.vue'
  import VASmallBox from '../widgets/VASmallBox.vue'
  import VAChatBox from '../widgets/VAChatBox.vue'
  import VATodoList from '../widgets/VATodoList.vue'
  import VAQuickMail from '../widgets/VAQuickMail.vue'
  import VACalendar from '../widgets/VACalendar.vue'
  import VAChart from '../components/VAChart'
  import Loading from 'vue-loading-overlay'
  import DownloadInstaller from '../components/DownloadInstaller'

  export default {
    name: 'dashboard',
    components: {
      DownloadInstaller,
      'va-small-box': VASmallBox,
      'va-chat-box': VAChatBox,
      'va-todo-list': VATodoList,
      'va-quick-mail': VAQuickMail,
      'va-calendar': VACalendar,
      'va-chart': VAChart,
      VueTable,
      Loading
    },
    data () {
      return {
        showAccounting: false,
        isFullpage: false,
        guidAlerts: this.$root.getGUID(),
        infoIcons: [
          { icon: 'fa fa-bell-o iconInformation smallIcon', label: 'System' },
          { icon: 'fa fa-exclamation-circle iconInformation rotate180 smallIcon', label: 'Information' },
          { icon: 'fa fa-exclamation-triangle iconWarning smallIcon', label: 'Warning' },
          { icon: 'fa fa-times-circle iconError smallIcon', label: 'Critical' }
        ],
        alertsColumns: [
          { fieldName: 'Type', label: '', isSortable: false, isHidden: false, isIcon: true },
          // { fieldName: 'CustomerName', label: 'Customer', isSortable: false, isHidden: false },
          { fieldName: 'Logged', label: 'Date', isSortable: false, isHidden: false },
          { fieldName: 'Message', label: 'Alert', isSortable: false, isHidden: false, length: 500 }
        ]
      }
    },
    created () {
      this.$root.title = 'Printer Counter Monitoring'
    },
    mounted () {
      if (this.$root.isFirstLogin) {
        $('#dashboardModal').modal('show')
      }

      try {
        CalculateDashboard(this, db)
      } catch (error) {
        console.log('CalculateDashboard error:' + error)
      }

      this.loadDashboard()
    },
    computed: {
      userFullName () {
        return this.$root.user.FirstName + ' ' + this.$root.user.LastName
      },
      hasChartData () {
        if (this.$root.dashData.barChartData.data.labels && this.$root.dashData.barChartData.data.labels.length > 0) {
          return true
        } else {
          return false
        }
      },
      hasAlertsData () {
        if (this.$root.dashData.recentAlerts && this.$root.dashData.recentAlerts.length > 0) {
          return true
        } else {
          return false
        }
      },
      totalAlertsData () {
        if (this.$root.dashData.recentAlerts && this.$root.dashData.recentAlerts.length > 0) {
          return this.$root.dashData.recentAlerts.length
        } else {
          return 0
        }
      }
    },
    watch: {
      '$root.dashData.recentAlerts' (val) {
        console.log(val)
      },
      totalAlertsData (val) {
        console.log('Total alerts = ' + val)
      }
    },
    methods: {
      loadDashboard () {
        let vm = this
        vm.$root.dashData = {
          TotalDealers: 100,
          TotalCustomers: 10,
          TotalSites: 10,
          TotalPrinters: 300,
          TotalUsers: 10,
          PrintersStatus: {
            TotalOnline: 0,
            TotalOffline: 0,
            TotalOutPaper: 0,
            TotalOutToner: 0,
            TotalError: 0
          },
          PrintersStatusPercent: {
            TotalOnline: '60%',
            TotalOffline: '10%',
            TotalOutPaper: '10%',
            TotalOutToner: '10%',
            TotalError: '10%'
          }
          // barChartData: ResetChartData(vm)
        }
      },
      addKeySpacing (mKey) {
        try {
          let sKey = ''
          if (mKey && mKey.length > 0) {
            let maxLength = Math.floor(mKey.length / 4)
            let chars = mKey.split('')
            let counter = 0
            for (let i = 0; i < chars.length; i++) {
              sKey += chars[i]
              counter++
              if (counter === maxLength) {
                sKey += ' '
                counter = 0
              }
            }
          }
          return sKey
        } catch (e) {
          console.log(e)
          return mKey
        }
      },
      rowClick (btn, item) {
        switch (btn) {
          case 'RefreshPrinter': this.refreshPrinter(item); break
          case 'InfoPrinter': this.info(item); break
          case 'Delete': this.confirmDelete(item); break
          default: break
        }
      }
    }
  }
  </script>

<style>
  .progress-group {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// Dashboard.vue?5a887df3